import moment, { Moment } from "moment";

import { Day } from "../gql/generated-types";
import { combineDateAndTime, isHoliday, today } from "./dates";

export const workedHours = (item?: Day | null) => {
  // calcolare ogni riga
  let totale = 0;
  item?.punches?.forEach((punch) => {
    let row = 0;
    if (punch?.out && punch?.in) {
      const end = moment(
        combineDateAndTime(item.date, punch?.out)
      );
      const startTime = moment(
        combineDateAndTime(item.date, punch?.in)
      );

      row = moment.duration(end.diff(startTime)).asHours();
    }
    // const roundedRow = roundToXDigits(row, 2);
    totale += row;
  });

  if (totale === 0) {
    return {
      ore: 0,
      minuti: 0,
      totale: 0
    };
  }
  const ore = Math.trunc(totale);
  const inMinuti = ore === 0 ? totale * 60 : (totale % ore) * 60;
  const minuti = Math.trunc(inMinuti);

  return {
    ore,
    minuti,
    totale
  };
};

export const getTodayFromDates = (
  days?: Day[]
): Day | undefined => {
  let _days: Day | undefined = undefined;

  days?.forEach((item) => {
    if (item.date === today()) {
      _days = item;
      return;
    }
  });

  return _days;
};

export const getVacationDays = (start: Moment, end: Moment) => {
  const vacations = [];

  for (let current = start; current <= end; current.add(1, "d")) {
    const _isHoliday = isHoliday(current.toDate());
    // console.log("date ", current.format("YYYY-MM-DD"));

    const isWeekEnd =
      current.format("d") === "0" || current.format("d") === "6";
    // rimuovo weekend e festivi
    if (!isWeekEnd && !_isHoliday) {
      vacations.push(current.format("YYYY-MM-DD"));
    }
  }

  return vacations;
};

export const isWeekendOrHoliday = (date: string) => {
  const _date = moment(date, "YYYY-MM-DD");
  const _isHoliday = isHoliday(moment(_date).toDate());
  // console.log("date ", current.format("YYYY-MM-DD"));

  const isWeekEnd = _date.format("d") === "0" || _date.format("d") === "6";
  // rimuovo weekend e festivi
  const _isWeekendOrHoliday = isWeekEnd || _isHoliday;

  // console.log(
  //   "date _isWeekendOrHoliday :>> ",
  //   `${date} => ${_isWeekendOrHoliday}`
  // );

  return _isWeekendOrHoliday;
};

export const getDayFromListByDate = (
  date: Moment,
  data: Day[]
): Day | undefined => {
  let listData = undefined;
  const calendarDate = moment(date).format("DD-MM-YYYY");
  data?.forEach((item: Day) => {
    const currentDate = moment(item.date).format("DD-MM-YYYY");
    if (currentDate === calendarDate) listData = item;
    return;
  });
  return listData;
};
